import { render, staticRenderFns } from "./CreateEventAddBattle.vue?vue&type=template&id=432a51ac&scoped=true"
import script from "./CreateEventAddBattle.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventAddBattle.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventAddBattle.vue?vue&type=style&index=0&id=432a51ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a51ac",
  null
  
)

export default component.exports